import React from 'react'

import Container from '../components/Container'
import Title from '../components/Title'

const Error404 = () => (
  <Container>
    <Title>Error 404</Title>
  </Container>
)

export default Error404
